<template>
  <button class="close-button" :class="{ inline }" @click="$emit('click')">
    <svg v-if="variant === 'light'" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16.329 16.329">
      <g id="Group_3927" data-name="Group 3927" transform="translate(0.75 0.75)">
        <path id="Path_8639" data-name="Path 8639" d="M-5614.277,60.126a.748.748,0,0,1-.53-.22.75.75,0,0,1,0-1.061l14.829-14.829a.75.75,0,0,1,1.061,0,.75.75,0,0,1,0,1.061l-14.829,14.829A.748.748,0,0,1-5614.277,60.126Z" transform="translate(5614.277 -44.547)" fill="#fff"/>
        <path id="Path_8640" data-name="Path 8640" d="M-5599.448,60.126a.748.748,0,0,1-.53-.22l-14.829-14.829a.75.75,0,0,1,0-1.061.75.75,0,0,1,1.061,0l14.829,14.829a.75.75,0,0,1,0,1.061A.748.748,0,0,1-5599.448,60.126Z" transform="translate(5614.277 -44.547)" fill="#fff"/>
      </g>
    </svg>
    <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16.329 16.329">
      <path id="Path_8639" data-name="Path 8639" d="M-5614.277,60.126a.748.748,0,0,1-.53-.22.75.75,0,0,1,0-1.061l14.829-14.829a.75.75,0,0,1,1.061,0,.75.75,0,0,1,0,1.061l-14.829,14.829A.748.748,0,0,1-5614.277,60.126Z" transform="translate(5615.027 -43.797)" fill="#140047"/>
      <path id="Path_8640" data-name="Path 8640" d="M-5599.448,60.126a.748.748,0,0,1-.53-.22l-14.829-14.829a.75.75,0,0,1,0-1.061.75.75,0,0,1,1.061,0l14.829,14.829a.75.75,0,0,1,0,1.061A.748.748,0,0,1-5599.448,60.126Z" transform="translate(5615.027 -43.797)" fill="#140047"/>
    </svg>
  </button>
</template>

<style lang="scss" scoped>
@import "~@/assets/scss/variables.scss";

.close-button {
  background: transparent;
  position: absolute;
  right: 20px;
  top: 10px;
  width: 28px;
  height: 28px;
  opacity: 1;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;

  &:focus {
    outline: none;
  }

  &.inline {
    position: relative;
    top: auto;
    right: auto;
    margin-left: auto;
  }
}
</style>

<script>
export default {
  name: "CloseButton",
  props: {
    variant: {
      type: String,
      default: "dark",
      validator: (value) => ["dark", "light"].includes(value),
    },
    inline: {
      type: Boolean,
      default: false,
    },
  },
};
</script>